import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'app-candidate-note-modal',
  templateUrl: './candidate-note-modal.component.html',
  styleUrls: ['./candidate-note-modal.component.css']
})
export class CandidateNoteModalComponent implements OnInit {
  @Input() isVisible: boolean = false;
  @Input() candidateName: string = '';
  @Input() candidateId: string = '';
  @Input() noteTypes: string[] = []; // Accept noteTypes as input from parent
  @Input() successMessage: string = '';
  @Input() loading: boolean = false;
  @Output() saveNote = new EventEmitter<{type: string, comments: string}>();
  @Output() closeModal = new EventEmitter<void>();

  selectedNoteType: string = '';
  noteComments: string = '';

  ngOnInit(): void {
    this.resetForm();
  }

  resetForm(): void {
    this.selectedNoteType = '';
    this.noteComments = '';
  }

  onSave(): void {
    if (this.selectedNoteType && this.noteComments.trim()) {
      this.saveNote.emit({
        type: this.selectedNoteType,
        comments: this.noteComments.trim()
      });
    }
  }

  onClose(): void {
    this.resetForm();
    this.closeModal.emit();
  }

  onCancel(): void {
    this.resetForm();
    this.closeModal.emit();
  }

  isFormValid(): boolean {
    return this.selectedNoteType !== '' && this.noteComments.trim() !== '';
  }
}